import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, ArrowLeft } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white pt-14" data-testid="commission-page">
      <div className="max-w-2xl mx-auto px-6 py-16 md:py-24">
        <h1 className="text-4xl md:text-5xl font-signature text-gray-900 mb-4 text-center" data-testid="commission-title">
          Commission
        </h1>
        <div className="w-16 h-0.5 bg-gray-300 mx-auto mb-8" />

        <p className="text-base font-signature text-gray-600 text-center mb-10 leading-relaxed max-w-lg mx-auto">
          Interested in commissioning a piece or inquiring about available works? I would love to hear from you.
        </p>

        <div className="space-y-6">
          {/* Email */}
          <a
            href="mailto:nikhitakapur@gmail.com"
            className="flex items-center gap-4 p-5 bg-gray-50 rounded-xl hover:bg-teal-50 transition-colors duration-300 group"
            data-testid="commission-email"
          >
            <div className="w-11 h-11 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-200 transition-colors flex-shrink-0">
              <Mail className="w-5 h-5 text-teal-600" />
            </div>
            <div>
              <p className="text-sm font-signature text-gray-500 mb-0.5">Email</p>
              <p className="text-base font-signature text-gray-800 group-hover:text-teal-700 transition-colors">nikhitakapur@gmail.com</p>
            </div>
          </a>

          {/* Instagram */}
          <a
            href="https://instagram.com/downtimeartist"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 p-5 bg-gray-50 rounded-xl hover:bg-pink-50 transition-colors duration-300 group"
            data-testid="commission-instagram"
          >
            <div className="w-11 h-11 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-pink-100 transition-colors flex-shrink-0">
              <Instagram className="w-5 h-5 text-teal-600 group-hover:text-pink-500 transition-colors" />
            </div>
            <div>
              <p className="text-sm font-signature text-gray-500 mb-0.5">Instagram</p>
              <p className="text-base font-signature text-gray-800 group-hover:text-pink-500 transition-colors">@downtimeartist</p>
            </div>
          </a>
        </div>

        {/* Back to About */}
        <div className="mt-12 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm font-signature text-teal-600 hover:text-teal-800 transition-colors"
            data-testid="commission-back-about"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to About
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
